import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@core/pipes';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'sc-empty-placeholder',
    imports: [TranslatePipe, AsyncPipe],
    templateUrl: './empty-placeholder.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmptyPlaceholderComponent {}
